/**
 * Brand preview: demo-only white-label skinning of Fitvent-owned surfaces
 * (organiser dashboard, MyFitvent hub, registration identity widget).
 *
 * A signed browser cookie activates the skin for that browser only. It is a
 * sales/demo tool, not a tenant system: nothing is stored per account and no
 * public surface changes for anyone without the cookie.
 *
 * The cookie value is `<brand>.<hmac>` where the HMAC is computed server-side
 * with a platform secret. Server components verify the signature before
 * applying the skin. Client components may check cookie presence only (they
 * render cosmetic strings, so a forged cookie gains nothing sensitive).
 */

export const BRAND_PREVIEW_COOKIE = 'fv-brand-preview';

export const BRAND_PREVIEW_IDS = ['hyrox'] as const;
export type BrandPreviewId = (typeof BRAND_PREVIEW_IDS)[number];

export function isBrandPreviewId(value: string | null | undefined): value is BrandPreviewId {
  return !!value && (BRAND_PREVIEW_IDS as readonly string[]).includes(value);
}

/** Parse the brand out of a raw cookie value WITHOUT verifying the signature.
 *  Client-side use only, for cosmetic rendering. */
export function parseBrandPreviewValue(raw: string | null | undefined): BrandPreviewId | null {
  if (!raw) return null;
  const brand = raw.split('.')[0];
  return isBrandPreviewId(brand) ? brand : null;
}
